module.exports = __webpack_public_path__ + "images/liinilaevad/apple-icon-60x60.png";